import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  OrderTableSettingsData,
  UseOrderTableSettingsParams,
  OrderTableSettingsQueryKey,
} from './types';
import { getOrderTableSettingsQueryKey } from './util';

export const useOrderTableSettings: QueryFunction<
  OrderTableSettingsData,
  [UseOrderTableSettingsParams],
  OrderTableSettingsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const { userId } = params;
  const queryKey = getOrderTableSettingsQueryKey(params);
  const request = useRequest(requestOptions);

  const isDisabled = queryOptions?.enabled === false || !userId;

  return useQuery({
    ...queryOptions,
    enabled: !isDisabled,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/users/${params.userId}/order_table_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
